import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import backRed from "../../../../../assets/svg/back-rose-icon.svg";
import Breadcrumbs from "../../../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SucessModal from "../../../../../components/Modal/SucessModal";
import "./form.scss";

const InClinicForm = () => {
  const {
    formState: { errors },
  } = useForm();
  const { id } = useParams();
  const location = useLocation();

  const [fields, setFields] = useState({});
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const onSubmit = (fields) => {
    axios
      .post(`${process.env.REACT_APP_API_URL}in-clinic-fee/create`, fields)
      .then((response) => {
        if (response.data?._id) {
          setSuccess(true);
        } else {
          alert("Fail");
          console.log("failed...");
        }
      });
  };

  const breadcrumbsList = useMemo(
    () => [
      { text: "Masters", link: "/master-primary-specialisation" },
      { text: "Doctors", link: "/master-primary-specialisation" },
      { text: "In Clinic Fee", link: "/master-inclinic-fee" },
      {
        text: location.pathname.includes("/master-inclinic-edit/")
          ? "Edit Inclinic Fee"
          : location.pathname.includes("/master-inclinic-view/")
            ? "View Inclinic Fee"
            : location.pathname === "/master-in-clinic-create"
              ? "Add New Inclinic Fee"
              : "",
        link: "",
      },
    ],
    [],
  );
  const handleUpdateData = () => {
    let item = { type: fields.type, active: fields.active };
    fetch(`${process.env.REACT_APP_API_URL}in-clinic-fee/update/${id}`, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    }).then((result) => {
      result.json().then((resp) => {
        setSuccess(true);
      });
    });
  };

  const getMenuData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}in-clinic-fee/get/${id}`)
      .then((response) => {
        setFields(response.data);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    if (
      location.pathname.includes("/master-inclinic-edit/") ||
      location.pathname.includes("/master-inclinic-view/")
    ) {
      getMenuData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      {/* <Home> */}
      <div
        onClick={() => navigate("/master-inclinic-fee")}
        className="rose back-button"
      >
        <img src={backRed} alt="" />
        <span className="rose-back">Back</span>
      </div>
      <div className="healtharticle">
        <div className="healtharticle-title carrer-job-title ms-4"></div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            location.pathname.includes("/master-inclinic-edit/")
              ? handleUpdateData()
              : onSubmit(fields);
          }}
          className="carr-dep-form"
        >
          <div className="row car-dep-form">
            <div className="col-5">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
                htmlFor=""
              >
                In-Clinic Fee <span className="star">*</span>
              </label>
              <input
                className="form-control w-75"
                type="text"
                name=""
                id="department"
                value={fields.type}
                onChange={(e) =>
                  setFields((prevState) => {
                    return { ...prevState, type: e.target.value };
                  })
                }
                disabled={location.pathname.includes("/master-inclinic-view/")}
                placeholder="Type here..."
              />
              {errors.type && (
                <div className={`invalid-feedback d-block`}>In-Clinic Fee</div>
              )}
            </div>

            <div className="col-3">
              <label
                className="car-dep-form-txt mb-2"
                style={{ color: "#4B4853" }}
                htmlFor=""
              >
                Active <span className="star">*</span>
              </label>
              <div className="d-flex">
                <div className="form-check form-check-inline me-3 mt-1">
                  <input
                    className="form-check-input me-3"
                    type="radio"
                    name="status"
                    id="status"
                    disabled={location.pathname.includes(
                      "/master-inclinic-view/",
                    )}
                    onChange={(e) => {
                      setFields((prevState) => {
                        return { ...prevState, active: true };
                      });
                    }}
                    value={true}
                    checked={fields.active === true ? "checked" : null}
                  />
                  <label htmlFor="option-1" className="text-dark ">
                    Active
                  </label>
                </div>
                <div className="form-check form-check-inline mt-1">
                  <input
                    className="form-check-input  me-3"
                    type="radio"
                    name="status"
                    id="status"
                    disabled={location.pathname.includes(
                      "/master-inclinic-view/",
                    )}
                    value={false}
                    onChange={(e) => {
                      setFields((prevState) => {
                        return { ...prevState, active: false };
                      });
                    }}
                    checked={fields.active === false ? "checked" : null}
                  />
                  <label htmlFor="option-2" className="text-dark">
                    Inactive
                  </label>
                </div>
              </div>
              {errors.active && (
                <div className={`invalid-feedback d-block`}>
                  Please select an Option
                </div>
              )}
            </div>
          </div>

          {(location.pathname === "/master-in-clinic-create" ||
            location.pathname.includes("/master-inclinic-edit/")) && (
            <div className="car-dep-form-button">
              <button type="submit" style={{ marginTop: "5%", border: "none" }}>
                {location.pathname === "/master-in-clinic-create"
                  ? "SUBMIT"
                  : location.pathname.includes("/master-inclinic-edit/")
                    ? "UPDATE"
                    : ""}
              </button>
            </div>
          )}
        </form>
      </div>
      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/master-inclinic-fee"}
          name="In-Clinic Fee"
          post="posted"
        />
      )}
    </>
  );
};

export default InClinicForm;
